import { requester } from "../utils";

export const channelMessageList = (data) => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/channel-message/me`,
        method: "POST",
        withAuth: true,
        data
      })
      .then((result) => {
        resolve(result.payload);
      })
      .catch((err) => {
        console.log("get channel-message list error", err);
        reject({ error: err });
      });
  });
};

export const getNewsList = (data, cityCode) => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/channel-message/news`,
        method: "POST",
        withAuth: false,
        cityCode: cityCode,
        data
      })
      .then((result) => {
        resolve(result.payload);
      })
      .catch((err) => {
        console.log("get news list error", err);
        reject({ error: err });
      });
  });
};